import React from "react";
import Markdown from "../utility/markdown";

const Alert = ({alert}) => (
    <div className="flex bg-emerald-200 rounded-3xl p-4 mb-4 text-sm text-emerald-700 dark:bg-emerald-700 dark:text-emerald-300 mb-14" role="alert">
        <svg className="w-8 h-8 inline mr-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd"></path></svg>
        <div>
        <div>
            <span className="text-2xl font-medium leading-none">{alert.title}</span>
        </div>
        <Markdown className="leading-none" body={alert.content.data.content}></Markdown>
        </div>
    </div>
)

export default Alert